import React from 'react';
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PlacesAutocomplete from 'react-places-autocomplete';
import API from "@beardeddevops/react.api";
import {Call_Geocode_API} from "../../constants/Utilities";
import {loadGoogleMaps} from "../../constants/GoogleMaps";

export default class Address extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		parent: PropTypes.object.isRequired,
		prefix: PropTypes.string,
		hasCounty: PropTypes.bool,
	};

	constructor(props) {
		super(props);
		this.state = {
			state: this.props.object.state || "",
			street_1: this.props.object.street_1 || "",
			city: this.props.object.city || "",
			zip: this.props.object.zip || "",
			selected: false,
			locationId: this.props.parent?.state?.pkey || null,
			mapsReady: false,
		};
	}

	async componentDidMount() {
		await loadGoogleMaps();
		this.setState({ mapsReady: true });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.object.state !== this.props.object.state) {
			this.setState({ state: this.props.object.state || "" });
		}
		if (prevProps.object.street_1 !== this.props.object.street_1) {
			this.setState({ street_1: this.props.object.street_1 || "" });
		}
		if (prevProps.object.city !== this.props.object.city) {
			this.setState({ city: this.props.object.city || "" });
		}
		if (prevProps.object.zip !== this.props.object.zip) {
			this.setState({ zip: this.props.object.zip || "" });
		}

		if (
			this.props.validateAddress &&
			prevProps.validateAddress !== this.props.validateAddress &&
			this.props.validateAddress !== 'validated'
		) {
			this.handleSelect(this.props.validateAddress);
		}

		if (
			this.props.customerAddress &&
			prevProps.customerAddress !== this.props.customerAddress &&
			this.props.customerAddress !== 'validated'
		) {
			this.handleSelect(this.props.customerAddress);
		}

		if (this.state.street_1 === "" && prevState.street_1 !== "" && this.props.condense) {
			this.props.parent.state.region = null;
			this.setState({
				city: "",
				state: "",
				zip: ""
			});
		}

		const nextLocationId = this.props.parent?.state?.pkey || null;
		if (nextLocationId !== this.state.locationId) {
			this.setState({
				selected: true,
				locationId: nextLocationId,
			});
		}
	}

	resetAddressFields = () => {
		this.setState({
			street_1: "",
			city: "",
			state: "",
			zip: "",
			selected: false,
		});

		this.props.parent.state.street_1 = "";
		this.props.parent.state.city = "";
		this.props.parent.state.state = "";
		this.props.parent.state.zip = "";
		this.props.parent.state.latitude = null;
		this.props.parent.state.longitude = null;
		this.props.parent.state.region = null;
	};

	handleChange = (street_1, city) => {
		let allow = false;

		if (!this.props.condense || !this.state.selected) {
			allow = true;
		} else if (street_1 === "") {
			allow = true;
			if (!city) {
				this.setState({ selected: false });
			}
		}

		if (!allow) return;

		if (street_1 === "" && city === "") {
			this.resetAddressFields();
		} else {
			this.setState({ street_1 });
			this.props.parent.state.street_1 = street_1;
			this.props.parent.state.latitude = null;
			this.props.parent.state.longitude = null;
		}

		const prefix = this.props.prefix || '';
		if (this.props.parent.state[prefix + 'street_1_error'] && typeof this.props.parent.setState === 'function') {
			this.props.parent.setState({ [prefix + 'street_1_error']: '' });
		}

		if (typeof this.props.searchChange === 'function') {
			this.props.searchChange(street_1);
		}

		if (typeof this.props.parent.props.validateAddress === 'function') {
			this.props.parent.props.validateAddress(null, null, '');
			this.props.parent.props.updateStreet(street_1);
		}
	};

	applyAddressData = (geo = {}) => {
		const street_1 = geo.street_1 || "";
		const city = geo.city || "";
		const state = geo.state || "";
		const zip = geo.zip || "";
		const latitude = geo.latitude ?? null;
		const longitude = geo.longitude ?? null;

		this.setState({
			street_1,
			city,
			state,
			zip,
		});

		this.props.parent.state.street_1 = street_1;
		this.props.parent.state.city = city;
		this.props.parent.state.state = state;
		this.props.parent.state.zip = zip;
		this.props.parent.state.latitude = latitude;
		this.props.parent.state.longitude = longitude;
		this.props.parent.state.validateAddress = 'validated';

		if (typeof this.props.parent.setState === 'function') {
			const prefix = this.props.prefix || '';
			this.props.parent.setState({
				[prefix + 'street_1_error']: '',
				[prefix + 'city_error']: '',
				[prefix + 'state_error']: '',
				[prefix + 'zip_error']: '',
			});
		}

		if (typeof this.props.parent.props.updateAddress === 'function') {
			this.props.parent.props.updateAddress({ state, setStreet: street_1, city, zip });
		}

		if (typeof this.props.updateAddress === 'function') {
			this.props.updateAddress({ state, setStreet: street_1, city, zip });
		}
	};

	loadRegion = async (lat, lng) => {
		let modelRegion = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ);
		modelRegion.filter = {
			latitude: lat,
			longitude: lng,
		};

		const regional = await modelRegion.submit(null, 'GET_REGION', true);

		if (regional && Object.keys(regional).length > 0) {
			this.props.parent.state.region = regional.regionPkey;
			this.props.parent.handleSelectPropertyUpdate();

			if (typeof this.props.parent.props.regionChange === 'function') {
				this.props.parent.props.regionChange(regional.regionName, regional.regionPkey);
			}

			if (typeof this.props.parent.props.updateRegion === 'function') {
				this.props.parent.props.updateRegion(regional.regionPkey, regional.regionName);
			}

			if (typeof this.props.parent.props.setAddress === 'function') {
				this.props.parent.props.setAddress([lat, lng, regional.regionPkey]);
			}

			if (typeof this.props.setRegion === 'function') {
				this.props.setRegion(regional.regionPkey);
			}
		} else {
			if (typeof this.props.parent.props.setAddress === 'function') {
				this.props.parent.props.setAddress([lat, lng, null]);
			}

			if (typeof this.props.setRegion === 'function') {
				this.props.setRegion(null);
			}
		}

		if (typeof this.props.parent.props.updateGivenAddress === 'function') {
			this.props.parent.props.updateGivenAddress(lat, lng);
		}
	};

	handleSelect = async (selectedAddress) => {
		try {
			if (typeof this.props.condense !== 'undefined') {
				this.setState({ selected: true });
			}

			const geo = await Call_Geocode_API(selectedAddress);

			if (!geo || geo.latitude == null || geo.longitude == null) {
				this.props.parent.state.validated = 'error';
				return;
			}

			this.applyAddressData(geo);

			if (typeof this.props.parent.props.validateAddress === 'function') {
				this.props.parent.props.validateAddress(geo.latitude, geo.longitude, 'validated');
			}

			if (typeof this.props.validateAddress === 'function') {
				this.props.validateAddress(geo.latitude, geo.longitude);
			}

			await this.loadRegion(geo.latitude, geo.longitude);
		} catch (error) {
			console.error('Error selecting address', error);
			this.props.parent.state.validated = 'error';
		}
	};

	render() {
		let object = this.props.object;
		let properties = this.props.properties;
		let { parent, prefix } = this.props;
		prefix = prefix || '';

		const displayValue = this.props.condense
			? [this.state.street_1, this.state.city, this.state.state, this.state.zip].filter(Boolean).join(', ')
			: this.state.street_1;
		const streetError = object[prefix + 'street_1_error'];
		const streetInputStyle = {
			width: "100%",
			height: "32px",
			...(streetError ? { border: '1px solid #d32f2f' } : {}),
		};

		return (
			<fieldset>
				<div className="form-group">
					{this.state.mapsReady ? (
					<PlacesAutocomplete
						value={displayValue}
						onChange={this.handleChange}
						onSelect={this.handleSelect}
					>
						{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
							<div>
								<input
									{...getInputProps({
										placeholder: 'Street',
										className: 'location-search-input',
									})}
									style={streetInputStyle}
									type="search"
									disabled={(this.state.selected && this.props.condense) || this.props.disabled}
								/>
								{streetError ? <div style={{color: '#d32f2f', fontSize: '0.8rem', marginTop: 4}}>{streetError}</div> : null}
								<div className="autocomplete-dropdown-container">
									{loading && <div>Loading...</div>}
									{suggestions.map((suggestion, index) => {
										const className = suggestion.active
											? 'suggestion-item--active'
											: 'suggestion-item';

										return (
											<div
												{...getSuggestionItemProps(suggestion, { className })}
												key={'item-' + index}
											>
												<span>{suggestion.description}</span>
											</div>
										);
									})}
								</div>
							</div>
						)}
					</PlacesAutocomplete>
					) : (
						<div>
							<input
								placeholder="Street"
								className="location-search-input"
								style={streetInputStyle}
								type="search"
								value={displayValue}
								disabled
							/>
							{streetError ? <div style={{color: '#d32f2f', fontSize: '0.8rem', marginTop: 4}}>{streetError}</div> : null}
						</div>
					)}
				</div>

				{(!this.props.hideFields && !this.props.condense) && (
					<div>
						<div className="form-group">
							<Framework.Elements.TextField
								label={"City"}
								property={properties[prefix + 'city']}
								value={this.state.city}
								error={object[prefix + 'city_error']}
								update={parent.handleTextFieldPropertyUpdate}
								disabled={this.props.disabled}
							/>
						</div>

						<div className="row">
							<div className="col-7">
								<div className="form-group" data-cy="address-state">
									<Framework.Elements.Select
										shouldLoad={parent.state.loaded}
										property={properties.state}
										value={this.state.state}
										error={object.state_error}
										model={Types.States._name}
										update={parent.handleSelectPropertyUpdate}
										id={'short'}
										label={"State"}
										nullable={true}
										limit={null}
										sort={'sort'}
										order={'asc'}
										disabled={this.props.disabled}
									/>
								</div>
							</div>

							<div className="col-5">
								<div className="form-group">
									<Framework.Elements.ZipCode
										label="Zip"
										property={properties[prefix + 'zip']}
										value={this.state.zip}
										error={object[prefix + 'zip_error']}
										update={parent.handleTextFieldPropertyUpdate}
										disabled={this.props.disabled}
									/>
								</div>
							</div>
						</div>
					</div>
				)}
			</fieldset>
		);
	}
}